import React from 'react';
import type { ConsentProfile } from 'types/nhis';
import { DetailContainer, DetailTitle, DetailTable, DetailRow, DetailLabel, DetailValue } from './styles';

/** 동의 5: 개인정보 및 민감정보 제3자 제공 동의 (기본판 20260423 / 늘품판 20260902 / K-MRS판) — 제공받는 자(담당 약사)만 판별로 바뀐다 */
const ConsentDetail5: React.FC<{ profile?: ConsentProfile }> = ({ profile }) => (
  <DetailContainer>
    <DetailTitle $kmrs={profile === 'kmrs'}>개인정보 및 민감정보 제3자 제공 동의</DetailTitle>
    <DetailTable>
      <tbody>
        <DetailRow>
          <DetailLabel>제공받는 자</DetailLabel>
          <DetailValue>
            {profile === 'kmrs'
              ? <><strong>담당 약사 (서울특별시약사회 소속 상담 약사)</strong></>
              : profile === 'caringnote'
              ? <><strong>담당 약사 (늘픔가치 소속 상담 약사)</strong></>
              : <><strong>담당 약사</strong> (서비스 진입 시 알림톡 전송을 요청한 약사)</>}
          </DetailValue>
        </DetailRow>
        <DetailRow>
          <DetailLabel>제공받는 목적</DetailLabel>
          <DetailValue>
            <ul>
              <li>담당 약사가 AI 보조 분석 자료 바탕으로 <strong>심층 검토</strong></li>
              <li>전문 <strong>복약 지도</strong></li>
              <li><strong>약사법상 의무 이행</strong></li>
            </ul>
          </DetailValue>
        </DetailRow>
        <DetailRow>
          <DetailLabel>제공하는 항목</DetailLabel>
          <DetailValue>
            <ul>
              <li>성명, 휴대전화번호</li>
              <li><strong>조회 내역 중 환자가 약사에게 제공하기로 '선택한' 과거 투약 이력</strong> (민감정보)</li>
              <li><strong>해당 데이터를 바탕으로 생성된 약사 전용 보조 분석 리포트 일체</strong></li>
            </ul>
          </DetailValue>
        </DetailRow>
        <DetailRow>
          <DetailLabel>이용 기간</DetailLabel>
          <DetailValue>
            <strong>정보를 제공받은 날로부터 5년</strong>
            <p className="note">
              ※ 약사법 등 관계 법령에 따른 조제 및 복약지도 기록 의무 보존 기간 준수
            </p>
          </DetailValue>
        </DetailRow>
        <DetailRow>
          <DetailLabel>동의 거부 권리 및 불이익</DetailLabel>
          <DetailValue>
            귀하는 본 개인정보 및 민감정보의 제3자 제공에 동의를 거부할 수 있습니다.
            <p className="note">
              ※ 단, 동의를 거부하실 경우 환자님의 투약 데이터가 담당 약사에게 전달될 수 없으므로, 본 서비스의 핵심인 약사의 맞춤형 상담을 받으실 수 없습니다.
            </p>
          </DetailValue>
        </DetailRow>
      </tbody>
    </DetailTable>
  </DetailContainer>
);

export default ConsentDetail5;
